<template>
	<div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <div class="p-grid">
          <div class="p-col-6 p-text-left">
            <h2>{{$t('notifications.title')}}</h2>
          </div>
          <div class="p-col-6 p-text-right">
            <Button v-if="notificationsEnhanced && notificationsEnhanced.length>0 && !$functions.isDemoMode(email)" :label="$t('notifications.download_button')" @click="download"/>
          </div>
        </div>
        <div class="irinox-form notifications" >
          <div v-if="notificationsEnhanced && notificationsEnhanced.length>0" class="p-grid">

            <div class="p-col-12 p-lg-4 filters-floating-panel">
              <div class="filters">
                <div class="title p-mb-3">{{$t('notifications.filters.title')}}</div>
                <div class="search-bar p-jc-between p-text-center p-mb-3" style="width: 100%;">
                  <i class="pi pi-search" />
                  <InputText v-model="filters.search" :placeholder="$t('notifications.filters.search')"  style="width: calc(100% - 60px); background: transparent;" :aria-label="$t('notifications.filters.search')"/>
                  <i class="pi pi-times" @click="function() {filters.search=null}"/>
                </div>
                <div class="p-mb-3">
                  <div class="filter-title p-mb-2">{{$t('notifications.filters.lab')}}</div>
                  <div v-for="(lab, index) in filters.labs" :key="lab" class="p-d-flex p-ai-center">
                    <Checkbox :inputId="'lab'+index" name="labs" :value="lab" v-model="filters.labsSelected" />
                    <label :for="'lab'+index">{{lab}}</label>
                  </div>
                  <div v-if="filters.labs.length==0">-</div>
                </div>
                <div class="p-mb-3">
                  <div class="filter-title p-mb-2">{{$t('notifications.filters.category')}}</div>
                  <div v-for="(cat, index) in filters.categories" :key="cat" class="p-d-flex p-ai-center">
                    <Checkbox :inputId="'cat'+index" name="categories" :value="cat" v-model="filters.categoriesSelected" />
                    <label :for="'cat'+index">{{$t('dashboard.categories.'+cat)}}</label>
                  </div>
                  <div v-if="filters.categories.length==0">-</div>
                </div>
                <div class="p-mb-4">
                  <div class="filter-title p-mb-2">{{$t('notifications.filters.notifications')}}</div>
                  <div class="p-d-flex p-ai-center">
                    <Checkbox inputId="not1" name="notifications" :value="type.ALARM" v-model="filters.notificationsSelected" />
                    <label for="not1">{{$t('notifications.filters.notifications_alarms')}}</label>
                  </div>
                  <div v-if="filters.categories.length==0">-</div>
                </div>
                <div class="p-mb-2">
                  <Button :label="$t('notifications.filters.clear_button')" class="p-button-secondary p-p-0" @click="clearFilters"/>
                </div>
              </div>
            </div>

            <div v-if="notifications && Object.keys(notifications).length>0" class="p-col-12 p-lg-8">
                <Accordion class="alarm-accordion" :activeIndex="[0]" :multiple="true" expandIcon="p-accordion-toggle-icon pi pi-chevron-down" collapseIcon="p-accordion-toggle-icon pi pi-chevron-up">
                      <AccordionTab v-for="(value, name) in notifications" :key="name">
                          <template #header>
                              <span class="icon-calendar" style="font-size: 20px; margin-right: .8rem;"/>
                              <span>{{formatDate(name)}}</span>
                          </template>
                          <div v-for="not in value" :key="not.id" 
                              :class="['alarm',{'alarm-inactive':not.type==type.ALARM && !not.payload.active},{'event':not.type==type.EVENT}]">

                            <img v-if="not.type==type.ALARM && not.payload.active" src="assets/irinox/icons/alarm_active.svg" :alt="$t('common.active')"/> 
                            <img v-else-if="not.type==type.ALARM && !not.payload.active" src="assets/irinox/icons/alarm_inactive.svg" :alt="$t('common.inactive')"/> 
                            <img v-else-if="not.type==type.EVENT" src="assets/irinox/icons/event.svg" style="margin: 0px 1.2rem 0px 0.2rem" alt="Event"/>

                            <div class="event-description">
                              <div>
                                <span class="appliance-info">{{$functions.fixModelName(not.appliance.modelNumber)}} - {{not.appliance.name?not.appliance.name:not.serialNumber}} ({{not.appliance.labName??'-'}})</span>
                              </div>

                              <div>
                                <span v-if="not.type==type.ALARM" class="alarm-name">{{not.payload.name?$t('alarms.'+not.payload.name):"-"}}</span>
                                <span v-if="not.type==type.ALARM" class="alarm-code">&nbsp;({{not.payload.name}})</span>

                                <span v-if="not.type==type.EVENT" class="alarm-name">{{not.payload.name?$t('events.'+not.payload.name):"-"}}</span>
                              </div>

                            </div>

                            <span class="alarm-time">{{formatTime(not.timestamp)}}</span> 
                          </div>
                      </AccordionTab>
                </Accordion>
            </div>
            <div v-else class="p-col-12">
              {{$t('notifications.empty_filter_result')}}
            </div>
            
          </div>
          <div v-else class="p-mt-1">
            {{$t('notifications.empty_list')}}
          </div>
        </div>
		</div>
	</div>

  <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('notifications.error_dialog')"
    :life="5000" @update:visible="dialog.error = $event" />

  <IrinoxDialogDark :visible="dialog.downloadSuccess" 
    mode="success" 
    :message="$t('notifications.download_success')"
    :life="3000" 
    @update:visible="dialog.downloadSuccess = $event" />

</template>

<script>
import AccountService from '../../service/AccountService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';
// import AlarmAccordion from "../AlarmAccordion.vue";
import {FilterService} from 'primevue/api';

export default {
    components: {
        IrinoxDialogDark,
        // AlarmAccordion,
    },
    data() {
        return {
          type: {
            ALARM: "ALM",
            EVENT: "EVT"
          },
          notificationsRaw: [],
          notificationsEnhanced: [],
          notificationsFiltered: [],
          notifications: {},
          filters: {
            search: null,
            labs: [],
            labsSelected: [],
            categories: [],
            categoriesSelected: [],
            notifications: [],
            notificationsSelected: []
          },
          dialog: {
            error: false,
            downloadSuccess: false
          }
        };
    },
    computed: {
      ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          appliances: 'appliances/appliances',
          is24hour: 'userdata/is24hour',
          email: 'userdata/email',
        }),
    },
    watch: {
      notificationsRaw: 'updateEnhanced',
      notificationsEnhanced: 'updateFiltered',
      'filters.search': 'updateFiltered',
      'filters.labsSelected': 'updateFiltered',
      'filters.categoriesSelected': 'updateFiltered',
      'filters.notificationsSelected': 'updateFiltered',
      notificationsFiltered: 'updateNotifications'
    },
    created() {
      this.accountService = new AccountService();
    },
    mounted() {
      this.accountService.setNotificationsRead(this.personaltoken);
      this.buildFilters();
      this.load();
    },
    methods: {
      buildFilters() {
        this.appliances.forEach(function(a) {
          if(a.labName && !this.filters.labs.includes(a.labName)) {
            this.filters.labs.push(a.labName);
          }
          if(!this.filters.categories.includes(a.type)) {
            this.filters.categories.push(a.type);
          }
        }.bind(this));
        this.filters.labs.sort();
        this.filters.categories.sort();
      },
      load() {
        this.accountService.getNotifications(this.personaltoken)
          .then(notifications => {
            this.notificationsRaw = notifications;
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      updateEnhanced() {
        this.notificationsEnhanced = [];
        this.notificationsRaw.forEach(function(n) {
          this.appliances.forEach(function(a) {
            if(n.serialNumber == a.serialNumber) {
              let obj = this.$functions.clone(n);
              obj.appliance = {
                modelNumber: a.modelNumber,
                category: a.type,
                name: a.name,
                labName: a.labName
              }
              this.notificationsEnhanced.push(obj);
            }
          }.bind(this));
        }.bind(this));
      },
      updateFiltered() {
        let temp = [];
        this.notificationsEnhanced.forEach(function(n) {
          let s = this.filters.search==null
            || FilterService.filters.contains(n.appliance.name, this.filters.search)
            || FilterService.filters.contains(n.appliance.modelNumber, this.filters.search);
          let l = this.filters.labsSelected.length==0 
            || FilterService.filters.in(n.appliance.labName, this.filters.labsSelected);
          let c = this.filters.categoriesSelected.length==0 
            || FilterService.filters.in(n.appliance.category, this.filters.categoriesSelected);
          let a = this.filters.notificationsSelected.length==0 
            || FilterService.filters.in(n.type, this.filters.notificationsSelected);
          if(s && l && c && a) {
            temp.push(n);
          }
        }.bind(this));
        this.notificationsFiltered = temp;
      },
      updateNotifications() {
        this.notifications = {};
        let n = this.$functions.clone(this.notificationsFiltered);
        if(n!=null && n.length>0) {
          n.sort((a,b) => this.$functions.compareNumbers(a, b, "timestamp"));
          for(let i=0; i<n.length; i++) {
            // let key = new Date(n[i].timestamp * 1000).toISOString().slice(0, 10);
            let key = this.$functions.utcDate(n[i].timestamp,1000).toISOString().slice(0, 10);
            if(this.notifications[key]==null) {
              this.notifications[key] = [];
            }
            this.notifications[key].push(n[i]);
          }
        }
      },
      clearFilters() {
        this.filters.search = null;
        this.filters.labsSelected = [];
        this.filters.categoriesSelected = [];
        this.filters.notificationsSelected = [];
      },
      download() {
        this.accountService.downloadNotifications(this.personaltoken)
          .then((data) => {
            this.dialog.downloadSuccess = true;
            let blob=new Blob([data], {type: 'application/vnd.ms-excel'});
            let link=document.createElement('a');
            link.href=window.URL.createObjectURL(blob);
            link.download="notification_"+new Date().getTime()+".csv";
            link.click();
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      formatDate(name) {
        try {
          return this.$d(new Date(name), "medium");
        } catch(err) {
          console.error(err);
          return "Invalid date";
        }
      },
      formatTime(timestamp) {
        try {
          if(this.is24hour) {
            return this.$d(this.$functions.utcDate(timestamp,1000), "time");
          } else {
            return this.$d(this.$functions.utcDate(timestamp,1000), "time12");
          }
        } catch(err) {
          console.error(err);
          return "N/A";
        }
      }
    }
}
</script>

<style scoped>

</style>